{/* ── MOBILE nav — scrollable ── */ }
<nav
  aria-label="Main navigation"
  className="menu-scroll-area min-h-0 flex-1 px-7 xs:px-8 sm:px-10"
>
  <div className="flex min-h-full flex-col justify-center py-2">
    <ul className="divide-y divide-white/[0.04]">
      {navLinks.map((link, index) => (
        <li key={link.href}>
          <Link
            href={link.href}
            onClick={onClose}
            className={`anim-item group flex items-center justify-between ${getMobilePadding()}`}
          >
            <div className="flex items-center gap-4">
              <span className="w-6 shrink-0 text-[9px] font-bold tabular-nums text-white/20 xs:text-[10px]">
                {String(index + 1).padStart(2, "0")}
              </span>
              <span
                className={`font-black uppercase tracking-tight text-white transition-colors duration-200 group-hover:text-amber-400 ${getMobileFontSize()}`}
              >
                {link.label}
              </span>
            </div>
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="ml-3 shrink-0 text-white/15 transition-all duration-200 group-hover:translate-x-1 group-hover:text-amber-400"
            >
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </Link>
        </li>
      ))}
    </ul>
  </div>
</nav>

{/* ── DESKTOP nav — scrollable ── */ }
<nav
  aria-label="Main navigation"
  className="menu-scroll-area min-h-0 flex-1 px-8 lg:px-12 xl:px-14"
>
  <div className="flex min-h-full flex-col justify-center py-2">
    <ul className="divide-y divide-white/[0.04]">
      {navLinks.map((link, index) => (
        <li key={link.href}>
          <Link
            href={link.href}
            onClick={onClose}
            className={`anim-item group flex items-center justify-between ${getDesktopPadding()}`}
          >
            <div className="flex items-center gap-3 lg:gap-4">
              <span className="w-6 shrink-0 text-[9px] font-bold tabular-nums text-white/20 lg:text-[10px]">
                {String(index + 1).padStart(2, "0")}
              </span>
              <span
                className={`font-black uppercase leading-none tracking-tight text-white transition-all duration-200 group-hover:text-amber-400 ${getDesktopFontSize()}`}
              >
                {link.label}
              </span>
            </div>
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="ml-3 shrink-0 text-white/10 transition-all duration-200 group-hover:translate-x-1 group-hover:text-amber-400"
            >
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </Link>
        </li>
      ))}
    </ul>
  </div>
</nav>